import { MutationHookOptions, useMutation } from '@apollo/client'
import gql from 'graphql-tag'
import { useContext } from 'react'
import { Context } from '@/context'
import { fragments } from '@/hooks/fragments'
import {
  ELanguageCode,
  Mutation,
  MutationCloseAuctionByIdArgs,
} from '@/schemaTypes'
import { auctionFragments } from './auctionFragments'

const CLOSE_AUCTION = gql`
  mutation closeAuctionById(
    $openAuctionId: ObjectId!
    $languageCode: ELanguageCode!
  ) {
    closeAuctionById(openAuctionId: $openAuctionId) {
      ...AuctionDetailsFragment
    }
  }
  ${fragments.customDealFormQuestion}
  ${fragments.formAnswers}
  ${auctionFragments.auctionDetails}
  ${fragments.address}
`

type TData = { closeAuctionById: Mutation['closeAuctionById'] }
type TVariables = {
  languageCode?: ELanguageCode
} & MutationCloseAuctionByIdArgs

export function useCloseAuctionById(
  opts: MutationHookOptions<TData, TVariables> = {},
) {
  const { language } = useContext(Context)

  const [closeAuctionById] = useMutation<TData, TVariables>(CLOSE_AUCTION, {
    ...opts,
    variables: { ...(opts.variables as TVariables), languageCode: language },
  })
  return closeAuctionById
}
